<app-spinner></app-spinner>
<div class="content">
  <!--Attribute Form  -->
  <div
    *ngIf="shown.attribute"
    class="col-md-12 col-sm-12 col-xs-12 col-lg-12"
    style="padding: 10px"
  >
    <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
      <mat-card-header>
        <mat-card-title>
          <div class="backcontainer">
            <div class="Back" (click)="backapimanager()">
              <img src="assets/img/icons/shape-1.png" /> <span>Back</span>
            </div>
          </div>
          <div class="headLabel">Add Attribute</div>
        </mat-card-title>
      </mat-card-header>

      <form [formGroup]="Attribute" class="example-form">
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
            Entity: *
          </div>
          <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
            <mat-form-field
              appearance="outline"
              class="example-full-width"
              style="width: 100%"
            >
              <input
                matInput
                placeholder=""
                formControlName="entityType"
                readonly
              />
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
            Unique Name: *
          </div>
          <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
            <mat-form-field
              appearance="outline"
              class="example-full-width"
              style="width: 100%"
            >
              <input
                (keypress)="handleInput($event)"
                matInput
                placeholder=""
                formControlName="name"
                value=""
              />
            </mat-form-field>
            <mat-error *ngIf="validator.UniqueAttribute">{{
              validator.errorMessage
            }}</mat-error>
          </div>
        </div>

        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
            UI Name:
          </div>
          <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
            <mat-form-field
              appearance="outline"
              class="example-full-width"
              style="width: 100%"
            >
              <input
                matInput
                placeholder=""
                formControlName="uiName"
                value=""
              />
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <mat-checkbox class="flabel" formControlName="isShowInfo"
            >Info Hightlights/Highlighted</mat-checkbox
          >
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <mat-checkbox class="flabel" formControlName="isShowAlgo"
            >Show Consider algorithm</mat-checkbox
          >
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <mat-checkbox class="flabel" formControlName="isUnique"
            >Unique</mat-checkbox
          >
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <mat-checkbox class="flabel" formControlName="isCustom"
            >Show in custom UI</mat-checkbox
          >
        </div>

        <div
          *ngIf="Attribute.value.isShowAlgo"
          class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
        >
          <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
            Correlation value:
          </div>
          <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
            <mat-form-field
              appearance="outline"
              class="example-full-width"
              style="width: 95%"
            >
              <input
                matInput
                placeholder=""
                type="text"
                (keypress)="numberOnly($event)"
                formControlName="correlationValue"
                value=""
              />
            </mat-form-field>
            <span> %</span>
            <mat-error *ngIf="validator.isCorrelation"
              >This Field is required</mat-error
            >
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
            <button
              [disabled]="!AttributeForm.valid"
              style="width: 100%"
              mat-flat-button
              class="btn"
              (click)="createAttribute()"
            >
              Add
            </button>
          </div>
        </div>
      </form>
    </mat-card>
  </div>
  <!--  -->

  <div *ngIf="shown.apiForm">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="top: 20px">
      <!-- <button mat-flat-button class="btn" (click)="apiList()">Back</button> -->

      <!-- Left side panel -->

      <form [formGroup]="apiManager" class="example-container">
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <mat-card class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <mat-card-header>
              <mat-card-title>
                <div class="backcontainer">
                  <div class="Back" routerLink="/ApiGroupForm">
                    <img src="assets/img/icons/shape-1.png" />
                    <span> Back</span>
                  </div>
                </div>

                <div *ngIf="!apiManagerId">Add Api</div>
                <div *ngIf="apiManagerId">Update Api</div>
              </mat-card-title>
            </mat-card-header>
            <div style="margin-top: 2%"></div>

            <div *ngIf="apiEdit.edit">
              <mat-form-field
                appearance="outline"
                name="request"
                style="width: 100%; display: none"
              >
                <mat-label>Api Id </mat-label>
                <input
                  matInput
                  placeholder="Request"
                  formControlName="apiId"
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
              <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <mat-form-field
                  appearance="outline"
                  name="request"
                  style="width: 100%"
                >
                  <mat-label>Source Name</mat-label>
                  <input
                    matInput
                    placeholder="Request"
                    formControlName="sourceName"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
              <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Input Entities</mat-label>
                  <!-- {{ entity | json }} -->
                  <mat-select
                    disableRipple
                    (selectionChange)="Entitychange($event.value)"
                    formControlName="entityType"
                  >
                    <mat-option
                      *ngFor="let entity of entity"
                      [value]="entity.entityId"
                    >
                      {{ entity.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                <div class="col-sm-10 col-xs-10 col-md-10 col-lg-10">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Required Attributes</mat-label>
                    <mat-select
                      multiple
                      disableRipple
                      formControlName="requiredAttributes"
                      (click)="Attributeshange($event.value)"
                    >
                      <!-- <mat-option
                        *ngFor="
                          let requiredAttribute of requiredAttribute
                            | orderBy : 'name'
                        "
                        [value]="requiredAttribute.Id"
                      >
                        {{ requiredAttribute.name }}
                      </mat-option>
                       -->
                      <mat-option
                        *ngFor="let reqAttribute of requiredAttributes"
                        [value]="reqAttribute.attributeId"
                      >
                        {{ reqAttribute.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="ChooseEntity"
                    >Please Choose Entity</mat-error
                  >
                </div>
                <div class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
                  <img
                    style="margin-top: 15px; height: 28px; width: 30px"
                    src="assets/img/icons/group-31.png "
                    (click)="AddAttribute()"
                  />
                </div>
              </div>
            </div>

            <div
              *ngIf="this.parentId == 0"
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
            >
              <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                <div
                  style="padding-left: 0px"
                  class="col-sm-10 col-xs-10 col-md-10 col-lg-10"
                >
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Choose Category</mat-label>
                    <mat-select
                      disableRipple
                      (selectionChange)="Categorychange($event.value)"
                      formControlName="category"
                    >
                      <mat-option
                        *ngFor="let cat of category"
                        [value]="cat.categoryId"
                      >
                        {{ cat.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
                  <img
                    style="margin-top: 15px; height: 28px; width: 30px"
                    src="assets/img/icons/group-31.png "
                    (click)="AddCategory()"
                  />
                </div>
              </div>

              <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                <div class="col-sm-10 col-xs-10 col-md-10 col-lg-10">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Choose Sub Category</mat-label>
                    <mat-select
                      formControlName="subCategory"
                      (selectionChange)="SubCategorychange($event.value)"
                    >
                      <mat-option
                        *ngFor="let subcat of subCategory"
                        [value]="subcat.subCategoryId"
                      >
                        {{ subcat.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="ChooseCategory"
                    >Please Choose Category</mat-error
                  >
                </div>
                <div class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
                  <img
                    style="margin-top: 15px; height: 28px; width: 30px"
                    src="assets/img/icons/group-31.png "
                    (click)="Addsubcategory()"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
              <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                <mat-form-field
                  appearance="outline"
                  name="url"
                  style="width: 100%"
                >
                  <mat-label>Enter URL</mat-label>
                  <input
                    matInput
                    placeholder="Enter URL"
                    formControlName="apiUrl"
                  />
                </mat-form-field>
              </div>

              <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Type</mat-label>
                  <mat-select formControlName="httpVerb">
                    <mat-option value="Get">Get</mat-option>
                    <mat-option value="Post">Post </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!--Dynamic header begin  -->
            <mat-card
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
              formArrayName="header"
            >
              <mat-label
                >Header
                <img
                  style="padding-left: 10px; height: 25px; width: 35px"
                  src="assets/img/icons/group-31.png "
                  (click)="addHeader()"
                />
              </mat-label>
              <!-- loop throught units -->
              <div
                class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
                *ngFor="
                  let unit of apiManager.get('header')['controls'];
                  let i = index
                "
              >
                <!-- row divider show for every nex row exclude if first row -->
                <mat-divider
                  *ngIf="
                    apiManager.get('header')['controls'].length > 1 && i > 0
                  "
                >
                </mat-divider>
                <br />

                <!-- group name in this case row index -->
                <div [formGroupName]="i">
                  <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutWrap
                    fxLayoutGap="3.5%"
                    fxLayoutAlign="center"
                  >
                    <mat-form-field
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label>Key</mat-label>
                      <input matInput placeholder="Key" formControlName="key" />
                      <!-- input field error -->
                    </mat-form-field>

                    <mat-form-field
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label></mat-label>
                      <mat-label>parameterType</mat-label>
                      <mat-select formControlName="parameterType">
                        <mat-option value="1">Hardcoded</mat-option>
                        <mat-option value="2">Mapped </mat-option>
                        <mat-option value="3">Formula </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="this.apiManager.value.header[i].parameterType == 1"
                      appearance="outline"
                      style="width: 30%"
                    >
                      <mat-label>Value</mat-label>
                      <input
                        matInput
                        placeholder="value"
                        type="text"
                        formControlName="value"
                      />
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="this.apiManager.value.header[i].parameterType == 3"
                      appearance="outline"
                      style="width: 30%"
                    >
                      <mat-label>Value</mat-label>
                      <textarea
                        matInput
                        placeholder="value"
                        formControlName="value"
                      >
                      </textarea>
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="!this.apiManager.value.header[i].parameterType"
                      appearance="outline"
                      style="width: 30%"
                    >
                      <mat-label>Value</mat-label>
                      <input
                        matInput
                        placeholder="value"
                        type="text"
                        formControlName="value"
                    /></mat-form-field>

                    <mat-form-field
                      *ngIf="this.apiManager.value.header[i].parameterType == 2"
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label></mat-label> <mat-label>Value</mat-label>
                      <mat-select formControlName="value">
                        <mat-option
                          *ngFor="let attr of Attribute | orderBy : 'name'"
                          [value]="attr"
                        >
                          {{ attr }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <img
                      style="padding-left: 6px; padding-bottom: 10px"
                      (click)="removeHeader(i)"
                      src="assets/img/icons/forma-1.png"
                    />
                  </div>
                </div>
              </div>
            </mat-card>
            <!--Dynamic Header End  -->
            <!--Dynamic Parameter Begin  -->
            <mat-card
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
              formArrayName="parameter"
            >
              <mat-label
                >Parameter
                <img
                  style="padding-left: 10px; height: 25px; width: 35px"
                  src="assets/img/icons/group-31.png "
                  (click)="addParameter()"
              /></mat-label>
              <!-- loop throught units -->
              <div
                class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
                *ngFor="
                  let parameter of apiManager.get('parameter')['controls'];
                  let i = index
                "
              >
                <!-- row divider show for every nex row exclude if first row -->
                <mat-divider
                  *ngIf="
                    apiManager.get('parameter')['controls'].length > 1 && i > 0
                  "
                >
                </mat-divider>
                <br />

                <!-- group name in this case row index -->

                <div [formGroupName]="i">
                  <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutWrap
                    fxLayoutGap="3.5%"
                    fxLayoutAlign="center"
                  >
                    <mat-form-field
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label>Key</mat-label>

                      <input matInput placeholder="Key" formControlName="key" />
                      <!-- input field error -->
                    </mat-form-field>

                    <mat-form-field
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label></mat-label>
                      <mat-label>parameterType</mat-label>
                      <mat-select formControlName="parameterType">
                        <mat-option value="1">Hardcoded</mat-option>
                        <mat-option value="2">Mapped </mat-option>
                        <mat-option value="3">Formula </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="
                        this.apiManager.value.parameter[i].parameterType == 1
                      "
                      appearance="outline"
                      style="width: 30%"
                    >
                      <mat-label>Value</mat-label>
                      <input
                        matInput
                        placeholder="value"
                        type="text"
                        formControlName="value"
                      />
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="
                        this.apiManager.value.parameter[i].parameterType == 3
                      "
                      appearance="outline"
                      style="width: 30%"
                    >
                      <mat-label>Value</mat-label>
                      <textarea
                        matInput
                        placeholder="value"
                        formControlName="value"
                      ></textarea>
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="!this.apiManager.value.parameter[i].parameterType"
                      appearance="outline"
                      style="width: 30%"
                    >
                      <mat-label>Value</mat-label>
                      <input
                        matInput
                        placeholder="value"
                        type="text"
                        formControlName="value"
                      />
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="
                        this.apiManager.value.parameter[i].parameterType == 2
                      "
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label></mat-label> <mat-label>Value</mat-label>
                      <mat-select formControlName="value">
                        <mat-option
                          *ngFor="let attr of Attribute | orderBy : 'name'"
                          [value]="attr.name"
                        >
                          {{ attr.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <!-- <mat-checkbox [checked]="this.apiManager.controls['parameter'].value[i].isPositional === true"  formControlName="isPositional" checked="{{this.apiManager.controls['parameter'].value[i].isPositional}}"  (change)="onChange($event, i, apiManager.controls.parameter.controls)"   style="width:10%;padding-right: 10px;padding-left: 10px">
										</mat-checkbox> -->

                    <img
                      style="padding-left: 6px; padding-bottom: 10px"
                      (click)="removeParameter(i)"
                      src="assets/img/icons/forma-1.png"
                    />
                  </div>
                </div>
              </div>
            </mat-card>
            <!--Dynamic Parameter End  -->

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
              <mat-form-field
                class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
                appearance="outline"
                name="preCondition"
                style="width: 100%; margin-top: 5px"
              >
                <mat-label>PreCondition</mat-label>
                <textarea
                  matInput
                  placeholder="preCondition"
                  formControlName="preCondition"
                >
                </textarea>
                <!-- -->
                <mat-error
                  *ngIf="apiManager.controls['preCondition'].errors?.required"
                  >Please enter a search text</mat-error
                >
              </mat-form-field>
            </div>

            <!--Sample Input Begin  -->
            <mat-card
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
              formArrayName="SampleInput"
            >
              <mat-label
                >Sample Input
                <img
                  style="padding-left: 10px; height: 25px; width: 35px"
                  src="assets/img/icons/group-31.png "
                  (click)="addSampleInput()"
              /></mat-label>
              <!-- loop throught units -->
              <div
                class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
                *ngFor="
                  let unit of apiManager.get('SampleInput')['controls'];
                  let i = index
                "
              >
                <!-- row divider show for every nex row exclude if first row -->
                <mat-divider
                  *ngIf="
                    apiManager.get('SampleInput')['controls'].length > 1 &&
                    i > 0
                  "
                >
                </mat-divider>
                <br />

                <!-- group name in this case row index -->
                <div [formGroupName]="i">
                  <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutWrap
                    fxLayoutGap="3.5%"
                    fxLayoutAlign="center"
                  >
                    <!-- <mat-form-field appearance="outline"
									style="width:30%;padding-right: 10px"> <mat-label>Key</mat-label>
								<input matInput placeholder="Key" formControlName="key">
								input field error </mat-form-field> -->

                    <mat-form-field
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                      <mat-label>Key</mat-label>
                      <mat-select disableRipple formControlName="key">
                        <mat-option
                          *ngFor="
                            let sinputAttribute of sinputAttribute
                              | orderBy : 'name'
                          "
                          [value]="sinputAttribute.name"
                        >
                          {{ sinputAttribute.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 30%">
                      <mat-label>Value</mat-label>
                      <input
                        matInput
                        placeholder="value"
                        type="text"
                        formControlName="value"
                      />
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline" style="width: 30%">
                      <mat-label>Type</mat-label>
                      <mat-select
                        formControlName="parameterType"
                        (selectionChange)="
                          onParameterTypeChange($event.value, i)
                        "
                      >
                        <mat-option value="1">string</mat-option>
                        <mat-option value="2">integer </mat-option>
                      </mat-select>
                    </mat-form-field> -->
                    <!-- <mat-form-field
                      *ngIf="
                        this.apiManager.value.SampleInput[i].parameterType1 == 1
                      "
                      appearance="outline"
                      style="width: 30%"
                    >
                    </mat-form-field>

                    <mat-form-field
                      *ngIf="
                        this.apiManager.value.SampleInput[i].parameterType1 == 2
                      "
                      appearance="outline"
                      style="width: 30%; padding-right: 10px"
                    >
                    </mat-form-field> -->

                    <img
                      style="padding-left: 6px; padding-bottom: 10px"
                      (click)="removeSampleInput(i)"
                      src="assets/img/icons/forma-1.png"
                    />
                  </div>
                </div>
              </div>
            </mat-card>
            <!--Sample Input End  -->
            <!-- <button [disabled]="!apiManager.valid" mat-flat-button class="next-btn" (click)="apiTest()">Test</button> -->

            <button
              [disabled]="!apiManager.valid"
              mat-flat-button
              class="btn"
              (click)="apiTest()"
            >
              View Response
            </button>
          </mat-card>
        </div>
      </form>

      <!-- Parent Response Begun-->
      <div class="col-md-4" *ngIf="apiParentResponse">
        <mat-card class="apimanagerParentresultpanel">
          <mat-card-header>
            <mat-card-title>Parent Response </mat-card-title>
          </mat-card-header>
          <!--Spinner Add  -->
          <div class="loader">
            <img *ngIf="ploader" src="assets/img/spinner.svg" />
          </div>

          <!-- Spinner End -->
          <div *ngIf="apiParentResponse">
            <pre style="height: 50vh">			{{ apiParentResponse | json }}</pre>
          </div>

          <div *ngIf="apiError">
            <pre style="height: 50vh; color: red">			{{ apiError | json }}</pre>
          </div>
        </mat-card>
      </div>
      <!-- Parent Response End  -->

      <div class="col-md-4">
        <mat-card class="apimanagerresultpanel">
          <mat-card-header>
            <mat-card-title>Response </mat-card-title>
          </mat-card-header>
          <!--Spinner Add  -->
          <div class="loader">
            <img *ngIf="loader" src="assets/img/spinner.svg" />
          </div>

          <!-- Spinner End -->

          <div *ngIf="apiResponse">
            <pre style="height: 80vh">			{{ apiResponse | json }}</pre>
          </div>

          <div *ngIf="apiError">
            <pre style="height: 60vh; color: red">			{{ apiError | json }}</pre>
          </div>
        </mat-card>

        <button
          [routerLink]="['/responseMapping']"
          [disabled]="!apiResponse"
          mat-flat-button
          class="btn"
        >
          Proceed To Response Mapping
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Chippset start -->
